<template>
  <div class="home-transfer">
    <h1 class="page-title title">{{ $t('transfer.title.transfer') }}</h1>
    <div class="page-ct">
      <div class="section">
        <h4 class="box-title title" v-if="isInitTransfer"><span>{{ $t('transfer.label.transfer') }}</span></h4>
        <h4 class="box-title title" v-if="isConfirmTransfer"><span>{{ $t('transfer.label.confirmation') }}</span></h4>
        <div class="box-ct">
          <form class="form-horizontal" v-if="isInitTransfer" name="inputAmount" @submit.prevent="transfer()" novalidate>
            {{model.infoMessage}}
            <div v-if="ntdFxMaintenance" class="alert alert-warning" v-html="$t('MSG_TRS_NAF_0193', { param0: $t('trs.front.header.label.fx') })"></div>

            <div v-if="model.successMessage || model.errorMessage || infoMessage">
              <div class="alert alert-success" v-if="model.successMessage">{{$t(model.successMessage)}}</div>
              <div class="alert alert-danger" v-else-if="model.errorMessage" v-html="$t(model.errorMessage, {param0: this.params.param0, param1: this.params.param1})"></div>
              <div class="alert alert-warning" v-else-if="infoMessage" v-html="$t(infoMessage)"></div>
            </div>
            <div class="section">
              <div class="section-inner">
                <h5 class="title no-border" v-html="transfer_from"></h5>
                <div style="margin-bottom: 12px;"><span v-html="$t('transfer.label.note2')"></span></div>
                <div class="bank-list">
                  <div class="row row-narrow">
                    <div class="col-md-3" v-for="item in listServiceFrom" :key="item.key">
                      <label :id="'lblFrom' + item.key" class="btn btn-border btn-block lblFrom" :disabled="item.isDisabled" :class="serviceFrom == item.key && !disableRadio[item.key] ? 'active': ''">
                        <input type="radio" name="serviceFrom" :value="item.key" v-model="serviceFrom" @click="changeFromAccount(item)" :disabled="item.isDisabled"/>{{$t(item.value)}}
                        <div class="text-center">{{$t('transfer.amount.available')}} {{availableAmount(item.key)}} {{ $t('currency.japanese.yen') }}</div>
                      </label>
                    </div>
                  </div>
                </div>
                <hr class="border-light" />
                <div class="tab-content">
                  <div class="tab-pane active">
                    <h5 class="title no-border" v-html="transfer_to"></h5>
                    <div class="bank-list">
                      <div class="row row-narrow">
                        <div class="col-md-3" v-for="item in listServiceTo" :key="item.key">
                          <label :id="'lblTo' + item.key" class="btn btn-border btn-block lblTo" :disabled="item.isDisabled" v-bind:class="serviceTo == item.key && !disableRadio[item.key] && !item.isDisabled? 'active': ''">
                            <input v-if="serviceTo != item.key" type="radio" name="serviceTo" v-model="serviceTo" :value="item.key" :disabled="item.isDisabled" @click="changeToAccount(item)">{{$t(item.value)}}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr class="border-light" />
                <h5 class="title no-border">{{ $t('transfer.label.transfer_amount') }}</h5>
                <div class="form-group">
                  <div class="col-md-4 pl-0">
                    <div class="input-group">
                      <input type="text" class="form-control moneyMask input-lg" :placeholder="$t('withdrawal.placeholder.amount')"
                             v-model="amount" name="amount" @blur="blur()" @keydown="amountKeyDown($event)" @keyup="amountKeyUp($event)" @keypress="amountKeyPress($event)"
                             @input="removeJapaneseCharacters($event)" :maxlength="19" aria-label="Amount (to the nearest dollar)" required />
                      <span class="input-group-addon currency-addon" style="padding: 10px 12px">{{ $t('currency.japanese.yen') }}</span>
                      <div class="error-messages ng-active" v-if="!isCorrectAmount">
                        <div>
                          {{ $t("deposit.alert.input.required") }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accounts-list">
                  <button id="#submit-btt" type="submit" class="btn btn-lg btn-success">{{ $t('transfer.button.label.transfer') }}</button>
                </div>
              </div>
            </div>
          </form>
          <div class="section-inner">
            <form class="form-horizontal" v-if="isConfirmTransfer">
              <div class="form-group">
                <div v-if="model.successMessage || model.errorMessage">
                  <div class="alert alert-success" v-if="model.successMessage">{{$t(model.successMessage)}}</div>
                  <div class="alert alert-danger" v-if="model.errorMessage">{{ $t(model.errorMessage, {param0: this.params.param0, param1: this.params.param1})}}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <table class="table table-noborder table-hover table-striped">
                    <tbody>
                      <tr>
                        <td>{{ $t('transfer.from.account') }}</td>
                        <td>{{$t(serviceTypeFromText)}} </td>
                      </tr>
                      <tr>
                        <td>{{ $t('transfer.to.account') }}</td>
                        <td>{{$t(serviceTypeToText)}}</td>
                      </tr>
                      <tr>
                        <td>{{ $t('transfer.label.amount') }}</td>
                        <td>{{amount}} <small class="currency-addon">{{ $t('currency.japanese.yen') }}</small></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <button id="submit-confirm-btt mr-2" @click.prevent="confirm()" class="btn btn-lg btn-success btn-padding-lg">{{ $t('transfer.button.label.confirm') }}</button>
              <button @click="back()" class="btn btn-default btn-lg btn-padding-lg ml-2"> {{ $t('transfer.button.label.back') }}</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import FHConvert from '@/common/converter/fhconvert';
import IConstants from "@/common/constants/IConstants.js";
import {MENU_HOME, SET_ACTIVE_TAB_ID} from '@/store/modules/header/type';
import {createNamespacedHelpers} from "vuex";
import {INPUT_NUMBER_ALLOW_KEY_CODE} from "@/common/constants";

const {mapActions: mapHeaderActions} = createNamespacedHelpers("header");

export default {
    data() {
        return {
            transfer_from: this.$t('transfer.label.transfer_from'),
            transfer_to: this.$t('transfer.label.transfer_to'),
            SERVICE_NAME: "transfer",
            model: {},
            serviceList: [],
            serviceTypeList: [],
            listServiceFrom: [],
            listServiceTo: [],
            disableRadio: [],
            serviceFrom: null,
            serviceTo: null,
            isInitTransfer: true,
            isCorrectAmount: true,
            showFromAccountInfo: false,
            showToAccountInfo: false,
            isConfirmTransfer: false,
            ntdFxMaintenance: false,
            balanceFromInfo: null,
            infoMessage: null,
            amount: null,
            serviceTypeFromText: null,
            serviceTypeToText: null,
            params: {},
            balanceInfo: null,
            result: null,
            clickSubmitted: false,
        }
    },
    created() {
        this[SET_ACTIVE_TAB_ID](MENU_HOME);
        this.initTransfer();
    },
    methods: {
        ...mapHeaderActions([
            SET_ACTIVE_TAB_ID
        ]),
        availableAmount(key) {
            if (this.balanceFromInfo[key]) {
                return this.$options.filters.moneyFormat(this.balanceFromInfo[key].availableAmount);
            }
            return 0;
        },
        initTransfer() {
            const self = this;
            this.$service
                .getService(this.SERVICE_NAME)
                .initTransfer()
                .then((result) => {
                    self.model = result;
                    self.tempList = self.IConstants.getListServiceTypeTransfer();
                    self.serviceList = result.serviceTypeList;
                    self.tempList.forEach((item) => {
                        self.serviceList.forEach((serviceType) => {
                            if (item.key == serviceType) {
                                self.serviceTypeList.push(item);
                            }
                        });
                    });
                    self.getBalanceFromAccount();
                });
        },

        getBalanceFromAccount() {
            const self = this;
            let params = "";
            this.serviceList.forEach((e) => {
                params += `serviceTypeList=${e}&`;
            });
            params = params.substring(0, params.length - 1);
            this.$service
                .getService(this.SERVICE_NAME)
                .getBalanceFromAccount(params)
                .then((result) => {
                    self.balanceFromInfo = result.mapBalanceTransferInfo;
                    self.showFromAccountInfo = true;
                    self.infoMessage = result.infoMessage;
                    self.disableRadio = result.disableRadio;
                    self.serviceTypeList.forEach((item) => {
                        item.isDisabled = self.disableRadio[item.key] != undefined ? self.disableRadio[item.key] : false;
                    });
                    self.listServiceFrom = JSON.parse(JSON.stringify(self.serviceTypeList));
                    self.listServiceTo = JSON.parse(JSON.stringify(self.serviceTypeList));
                    self.serviceFrom = 0;
                    self.serviceTo = 21;
                    self.changeFromAccount(self.listServiceFrom[0]);
                    this.setMaintenanceStatus(result);
                });
        },

        setMaintenanceStatus(response) {
            this.ntdFxMaintenance = response.ntdFxMaintenance;
        },

        changeFromAccount(selectedService) {
            const self = this;
            self.serviceTypeFromText = selectedService.value;
            self.serviceFrom = selectedService.key;
            self.listServiceTo.forEach(function (item) {
                if (item.key == self.serviceFrom) {
                    item.isDisabled = true;
                } else {
                    if (self.disableRadio[item.key] == undefined || self.disableRadio[item.key] == false) {
                        item.isDisabled = false;
                    }
                }
            });
            if (self.serviceFrom == self.serviceTo) {
                for (var item in self.listServiceTo) {
                    if (!self.listServiceTo[item].isDisabled) {
                        self.serviceTo = self.listServiceTo[item].key;
                        self.serviceTypeToText = self.listServiceTo[item].value;
                        return;
                    }
                }
            } else {
                for (var r in self.listServiceTo) {
                    if (self.listServiceTo[r].key == self.serviceTo) {
                        self.serviceTypeToText = self.listServiceTo[r].value;
                        return;
                    }
                }
            }
        },
        changeToAccount(selectedService) {
            this.serviceTypeToText = selectedService.value;
        },

        transfer() {
            const self = this;
            self.clickSubmitted = true;
            self.isCorrectAmount = this.isValidAmount(self.amount);
            if (!self.isCorrectAmount) {
                return;
            }
            $("#submit-btt").prop('disabled', true);
            self.model.successMessage = null;
            self.model.errorMessage = null;
            this.$service
                .getService(this.SERVICE_NAME)
                .transfer(this.getInputParams())
                .then((response) => {
                    self.balanceInfo = response.balanceTransferInfo;
                    if (response.errorMessage != null) {
                        self.model.errorMessage = response.errorMessage;
                        if (self.model.errorMessage === "MSG_NAB095") {
                            self.params = {
                                param1: response?.transferMoneyInfo?.minTransferAmount ?? 0 + '円'
                            }
                        }
                        if (self.model.errorMessage === "MSG_TRS_NAF_0193") {
                            self.params = {
                                param0: IConstants.getServiceTypeName(response.serviceMaintenance, IConstants.getMapAccountTypePeriodReport(false))
                            }
                        }
                    } else if (response.errorMessageInfo != null) {
                        var info = response.errorMessageInfo;
                        self.model.errorMessage = info.errorMessage;
                        self.params = {param1: info.param1}
                    } else {
                        self.isInitTransfer = false;
                        self.isConfirmTransfer = true;
                    }
                    window.scrollTo(0, 0);
                });
            setTimeout(function () {
                $("#submit-btt").prop('disabled', false);
            }, 2000);
        },

        getInputParams() {
            var transferMoney = this.amount;
            var params = new FormData();
            params.append("transferMoneyInfo.transferFrom", this.serviceFrom);
            params.append("transferMoneyInfo.transferTo", this.serviceTo);
            params.append("transferMoneyInfo.transferMoney", transferMoney.replace(/,/g, ''));
            return params;
        },

        back() {
            this.isInitTransfer = true;
            this.isConfirmTransfer = false;
        },

        confirm() {
            const self = this;
            $("submit-confirm-btt").prop('disabled', true);
            this.$service
                .getService(this.SERVICE_NAME)
                .confirm(this.getInputParams())
                .then((response) => {
                    self.balanceInfo = response.balanceTransferInfo;
                    if (response.errorMessage === null) {
                        self.model.errorMessage = null;
                        $("input[name=amount]").val('');
                        this.amount = $("input[name=amount]").val();
                        self.model.successMessage = response.successMessage;
                    } else {
                        $("input[name=amount]").val('')
                        this.amount = $("input[name=amount]").val();
                        self.model.successMessage = null;
                        self.model.errorMessage = response.errorMessage;
                        if (self.model.errorMessage === "MSG_TRS_NAF_0193") {
                            self.params = {
                                param0: IConstants.getServiceTypeName(response.serviceMaintenance, IConstants.getMapAccountTypePeriodReport(false))
                            }
                        }
                    }
                    self.isInitTransfer = true;
                    self.isConfirmTransfer = false;
                    self.getBalanceFromAccount();
                    // self.inputAmount.$submitted = false;
                    window.scrollTo(0, 0);
                });
            setTimeout(function () {
                $("#submit-btt").prop('disabled', false);
            }, 2000);
        },

        blur() {
            var amount = $("input[name=amount]").val();
            this.amount = this.formatAmount(amount, 15);
            $("input[name=amount]").val(this.amount);
            if (this.clickSubmitted) {
                this.isCorrectAmount = this.isValidAmount(this.amount);
            }
        },

        amountKeyPress(e) {
            let isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            if (isIOS) {
                let keyCode = e.keyCode || e.charCode;
                let charCode = e.charCode;
                let isArrow = (charCode == 0 && keyCode >= 37 && keyCode <= 40);
                let isSpecialCharacter = ((keyCode == 8) || (keyCode == 9) || (keyCode == 127)) || isArrow; // backspace, tab, delete
                let isNumber = (keyCode >= 48 && keyCode <= 57) ;  // numbers
                if (isNumber || isSpecialCharacter || keyCode == 44 || keyCode == 46) { // 44: comma, 46: dot
                    return true;
                } else {
                    e.preventDefault();
                    return false;
                }
            }
        },

        amountKeyUp(e) {
            if (this.clickSubmitted) {
                this.isCorrectAmount = this.isValidAmount(this.amount);
            }

            let amount = e.target.value;
            let charCode = e.keyCode || e.which;
            const regexNotAllowSpecialCharacters = /[^\d,.]/g;

            amount = amount.replace(regexNotAllowSpecialCharacters,"");

            // Default keycode for android is 0 or 299
            if (charCode === 0 || charCode === 229) {
                charCode = this.getKeyCode(amount);
            }

            if (!INPUT_NUMBER_ALLOW_KEY_CODE.includes(charCode)) {
                e.target.value = amount.replace(/^[0-9,.]/, '');
            }

            const MAX_LENGTH = 19;
            if (amount && amount.length >= MAX_LENGTH) {
                amount = amount.replace(regexNotAllowSpecialCharacters,"");
                e.target.value = amount.substr(0, MAX_LENGTH);
                return false;
            }

            e.target.value = amount.replace(regexNotAllowSpecialCharacters, '');
            return false;
        },

        amountKeyDown(e) {
            let allowInputAfterSelected = window.getSelection().toString() !== '';
            const charCode = (e.which) ? e.which : e.keyCode;
            if (!INPUT_NUMBER_ALLOW_KEY_CODE.includes(charCode) || e.shiftKey) {
              e.preventDefault();
              return false;
            }
            var val = $("input[name=amount]").val();

            if (!allowInputAfterSelected && val && val.length >= 19 && !(charCode == 37 || charCode == 38 || charCode == 39 || charCode == 40 || charCode == 8 || charCode == 46 || charCode == 116)) {
                e.preventDefault();
                return false;
            }
        },

        removeJapaneseCharacters(e) {
            let amount = e.target.value;
            const MAX_LENGTH = 19;
            const regexNotAllowSpecialCharacters = /[^\d,.]/g;
            e.target.value = amount.replace(regexNotAllowSpecialCharacters, '');

            if (amount && amount.length >= MAX_LENGTH) {
                amount = amount.replace(regexNotAllowSpecialCharacters,"");
                e.target.value = amount.substr(0, MAX_LENGTH);
                return false;
            }
        },

        getKeyCode(str) {
            return str.charCodeAt(str.length - 1);
        },

        formatAmount(val, maxLength) {
            if (val != null && val != "") {
                val = val.toString();
                val = FHConvert.ftoh(val);
                val = val.replace(/[^0-9]/g, '');
                val = parseFloat(val) + '';
                if (isNaN(val)) {
                    return '';
                }
                if (maxLength)
                    val = val.substr(0, maxLength);
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            } else {
                return val;
            }
        },
        isValidAmount(amount) {
            return amount !== undefined && amount !== null && amount !== "";
        },
    },
};
</script>
